import {DiplomaData} from "../Model/DiplomaData";
import {SafetyData} from "../Model/SafetyData";
import {Quiz, QuizData, QuizInputData} from "../Model/QuizData";
import {Settings} from "../Model/GameData";
import {FirstAidKitData} from "../../FirstAidKit/Model/FirstAidKitData";
import arrayShuffle from "array-shuffle";

export default class Network {
    private static BaseUrl = 'https://services.amistad.pl/pot/'
    // private static BaseUrl = 'https://tomcatdev.amistad.pl:8443/pot/'

    static loadQuiz(name: string, callback : (quiz? : QuizData) => void) {
        fetch(this.BaseUrl + name, {
            headers: {
                'Accept': 'application/json; type=www'
            },
        })
            .then(response => response.json())
            .then(data => {
                callback(this.convert(data))
            })
    }

    static loadSafety(callback : (safety? : SafetyData) => void) {
        fetch(this.BaseUrl + "safety", {
            headers: {
                'Accept': 'application/json; type=www'
            },
        })
            .then(response => response.json())
            .then(data => {
                data.tasks = data.tasks.filter(task => task.obligatory)
                callback(data)
            })
    }

    static loadFirstAidKit(callback : (safety? : FirstAidKitData) => void) {
        fetch(this.BaseUrl + "firstAidKit", {
            headers: {
                'Accept': 'application/json; type=www'
            },
        })
            .then(response => response.json())
            .then(data => {
                data.items = arrayShuffle(data.items)
                callback(data)
            })
    }

    static sendDiploma(blob: Blob, callback : (data: DiplomaData) => void) {
        const formData = new FormData()
        formData.append('DiplomaImage', blob, "DiplomaImage.jpg")
        fetch(this.BaseUrl + 'diploma', {
            method: 'POST',
            body: formData,

        })
            .then(response => response.json())
            .then(data => callback(data as DiplomaData))
    }

    static pictureUrl(url : string) : string {
        return url
    }

    private static convert(src : QuizInputData) : QuizData {
        return  {
            settings : src.settings as Settings,
            list : Object.entries(src)
                .filter(([k,v]) => k !== "settings")
                .map(([k,v]) => v as Quiz)
        }
    }
}